import { Typography } from '@utmost.co/utmost-design-system';
import React, { FC } from 'react';
import styled from 'styled-components';
import { PermissionPolicyLink } from './PolicyLink';
import { FieldPermission } from '../../../forms';
import { CopyPermissionResource } from '../CopyPermissionResource';

interface Props {
  permission?: FieldPermission;
  resourceUid?: string;
}

export const PermissionsCard: FC<Props> = ({ permission, resourceUid }) => {
  return (
    <StyledContainer>
      <StyledHeader>
        <Typography variant="h4">Permission Details</Typography>
        <Typography variant="body1">Permissions applied to the user on resource</Typography>
        <CopyPermissionResource resourceUid={resourceUid} />
      </StyledHeader>
      <PermissionPolicyLink permissionKey="READ" permission={permission} resourceUid={resourceUid} />
      <PermissionPolicyLink permissionKey="UPDATE" permission={permission} resourceUid={resourceUid} />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacingSize.ml} ${theme.spacingSize.l}`};
  width: 320px;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  margin-bottom: 24px;
`;
